import PropTypes from 'prop-types';
import React from 'react';
import CustomModal from '../../molecules/Modal';

function ModalBankAccounts({ open, onOkClick }) {
  return (
    <CustomModal
      title="Atenção"
      onOk={() => onOkClick()}
      open={open}
      closable={false}
      cancelButtonProps={{ style: { display: 'none' } }}
    >
      <div>
        <p>Caro Gestor,</p>
        <p>
          <strong>
            Fique atento aos novos dados bancários da Nova Cooperativa que constam no corpo da Fatura emitida, estes
            dados que deverão ser considerados para pagamento:
          </strong>
        </p>
        <p style={{ marginBottom: '0px' }}>Faturamento SP</p>
        <p style={{ padding: '5px', backgroundColor: '#ffe082' }}>
          <span>Nova Cooperativa de Trabalho</span>
          <br />
          <span>CNPJ 33.240.723/0001-17</span>
          <br />
          <span>Banco Santander</span>
          <br />
          <span>Ag. 4259-2</span>
          <br />
          <span>c/c 13006042-6</span>
          <br />
          <span>PIX credito13006042@novacoop.com.br</span>
        </p>
        <p style={{ padding: '5px', backgroundColor: '#ffe082' }}>
          <span>Nova Cooperativa de Trabalho</span>
          <br />
          <span>CNPJ 33.240.723/0001-17</span>
          <br />
          <span>Banco Bradesco</span>
          <br />
          <span>Ag. 3392</span>
          <br />
          <span>c/c 2132-6</span>
          <br />
          <span>PIX credito2132@novacoop.com.br</span>
        </p>
        <p style={{ marginBottom: '0px' }}>Faturamento BH</p>
        <p style={{ padding: '5px', backgroundColor: '#ffe082' }}>
          <span>Nova Cooperativa de Trabalho</span>
          <br />
          <span>CNPJ 33.240.723/0002-06</span>
          <br />
          <span>Banco Santander</span>
          <br />
          <span>Ag. 3554</span>
          <br />
          <span>c/c 13011477-9</span>
          <br />
          <span>PIX credito13011477@novacoop.com.br</span>
        </p>
      </div>
    </CustomModal>
  );
}

ModalBankAccounts.propTypes = {
  open: PropTypes.bool.isRequired,
  onOkClick: PropTypes.func.isRequired,
};

export default ModalBankAccounts;
